<template>
  <div>
    <Header state="account" />
    <div>
      <div class="empty" v-if="coinData.length === 0">
        <div class="empty-icon">
          <i class="fa fa-btc"></i>
        </div>
        <p class="empty-title h5">You have no coins</p>
        <p class="empty-subtitle">Click the button to add a coin to your wallet.</p>
        <div class="empty-action">
          <button class="btn btn-primary" @click="goToAddNewCoin">
            <i class="fa fa-plus"></i> Add
          </button>
        </div>
      </div>
      <div v-if="coinData.length > 0">
        <div class="summary">
          <div class="net-worth-text">
            <span>NET WORTH</span>
          </div>
          <h2>{{helper.getCurrencyString(totals.worth)}}<small>GBP</small></h2>
          <div class="percent-change-text">
            <i class="fa fa-arrow-up" v-if="totals.worth > totals.investment" aria-hidden="true"></i>
            <i class="fa fa-arrow-down" v-if="totals.worth < totals.investment" aria-hidden="true"></i>
            <span :class="{ 'increase': totals.worth > totals.investment, 'decrease': totals.worth < totals.investment }">
              {{helper.getCurrencyString(totals.worth - totals.investment)}}
              ({{helper.getPercentageString((1 - (totals.investment / totals.worth)) * 100)}}%)
            </span>
          </div>
        </div>
        <CoinCard v-for="coin in coinData" :key="coin.code" :coinData="coin" />
        <div class="empty-action text-center">
          <button class="btn btn-primary" @click="goToAddNewCoin">
            <i class="fa fa-plus"></i> Add
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Router from '@/router';
import Service from '@/service';
import Header from '@/components/header/Header';
import CoinCard from '@/components/card/CoinCard';
import Helper from '@/utils/Helper';

export default {
  name: 'Account',
  components: {
    Header,
    CoinCard,
  },
  data() {
    return {
      helper: Helper,
      coinData: [],
      totals: {
        investment: 0,
        worth: 0,
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      const userInputData = Service.getPurchase();
      const ids = userInputData.filter(elem => elem.id).map(elem => elem.id) || [];

      let apiData = [];
      Service.getCoinsByIds(ids.join(',')).then((response) => {
        if (response && response.status === 'success') {
          if (response.data && response.data.coins) {
            apiData = response.data.coins;
          }
        }
        this.performMagic(userInputData, apiData);
      });
    },
    performMagic(userInputData, apiData) {
      const userData = this.setUniquePurchases(userInputData);

      this.coinData = this.combineUserAndApiData(userData, apiData);

      this.totals = this.calcTotals(this.coinData);
    },
    setUniquePurchases(userInputData) {
      const uniquePurchases = {};
      userInputData.forEach((purchase) => {
        if (uniquePurchases[purchase.code]) {
          uniquePurchases[purchase.code].amount += purchase.amount;
          uniquePurchases[purchase.code].purchasePrice += purchase.purchasePrice;
        } else {
          uniquePurchases[purchase.code] = purchase;
        }
      });

      const purchaseArray = [];
      Object.keys(uniquePurchases).forEach((key) => {
        purchaseArray.push(uniquePurchases[key]);
      });
      return purchaseArray;
    },
    combineUserAndApiData(userData, apiData) {
      const coinData = [];
      userData.forEach((coin) => {
        const tempCoin = {};
        const apiCoin = this.getCoinFromArray(apiData, coin.code);
        if (apiCoin) {
          tempCoin.id = apiCoin.id;
          tempCoin.iconUrl = apiCoin.iconUrl;
          tempCoin.name = apiCoin.name;
          tempCoin.code = coin.code;
          tempCoin.amount = coin.amount;
          tempCoin.price = parseFloat(apiCoin.price) || 0;
          tempCoin.purchaseCurrency = coin.purchaseCurrency;
          tempCoin.purchasePrice = coin.purchasePrice;
          tempCoin.worth = apiCoin.price * coin.amount;
          coinData.push(tempCoin);
        } else {
          coinData.push(Object.assign(coin, {
            worth: coin.purchasePrice,
            price: coin.purchasePrice / coin.amount,
          }));
        }
      });
      return coinData;
    },
    getCoinFromArray(haystack, needle) {
      if (haystack && haystack.length > 0) {
        for (let i = 0; i < haystack.length; i += 1) {
          if (haystack[i].symbol === needle) {
            return haystack[i];
          }
        }
      }
      return false;
    },
    calcTotals(coinData) {
      const totals = {
        investment: 0,
        worth: 0,
      };
      coinData.forEach((purchase) => {
        totals.investment += purchase.purchasePrice;
        totals.worth += (purchase.price * purchase.amount);
      });
      return totals;
    },
    goToAddNewCoin() {
      Router.push({ name: 'Search' });
    },
  },
};
</script>

<style lang="scss" scoped>
  .empty {
    background: none;

    .fa-btc {
      font-size: 4rem;
    }
  }

  button {
    background: #673AB7;
    width: 5rem;
    margin-top: 0.5rem;
  }

  div.summary {
    padding: 0.5rem;
    background-color: #757575;
    color: #9E9E9E;
    box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);

    div.net-worth-text,  {
      padding-top: 1rem;
      text-align: center;
      margin-bottom: 0.5rem;
    }

    h2 {
      font-size: 2rem;
      text-align: center;
      color: #E0E0E0;
      margin-bottom: 0.5rem;

      small {
        font-size: 1rem;
        padding-left: 0.5rem;
      }
    }

    div.percent-change-text {
      text-align: center;
      margin-bottom: 0.5rem;

      .increase, .fa-arrow-up {
        color: #4CAF50;
      }

      .decrease, .fa-arrow-down {
        color: #f44336;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/Account.vue